import { useDispatch } from 'react-redux'
import * as routerActions from 'connected-react-router'

// Components
import { Button, IconLock, Tooltip } from '@tracklib/kit'
import { LicensePrice } from 'components/base/price'

// Hooks
import { useProfile } from 'modules/profile/hooks'

// Types
import { UserSong, Song, Track } from 'types'

import styles from './licensebutton.css'

type LicenseButtonProps = {
  song: Song
  track?: Track
  className?: string
  userSong?: UserSong
  isLoop?: boolean
  variant?: string
  size?: string
}

const LicenseButton = ({ song, track, userSong, isLoop, className, variant, size }: LicenseButtonProps): JSX.Element | null => {
  const dispatch = useDispatch()
  const profile = useProfile()
  const trackId = track?.id
  const unpublished = ![2, 3].includes(song.state)
  const isOwned = trackId && profile.purchased_tracks.map(x => x.track).indexOf(trackId) !== -1
  const button = (
    <Button
      title="License song"
      datatesting="license_button"
      onClick={() => dispatch(routerActions.push(`/pay/license/${userSong?.samples[0].license_order || ''}/`))}
      disabled={unpublished}
      className={className}
      ariaLabel="License song"
      variant={variant}
      size={size}
    >
      <IconLock className={styles.iconLock} />
      <span className={styles.buttonText}>License</span>
      <span datatesting="button_price">
        <LicensePrice category={song.licenseinfo.license_price_category} />
      </span>
    </Button>
  )
  if ((isOwned || userSong) && !isLoop) {
    return unpublished ? (
      <div data-tooltip-wrapper style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
        <Tooltip>This song is no longer available on Tracklib. Contact support for more info.</Tooltip>
        {button}
      </div>
    ) : (
      button
    )
  }
  return null
}

export default LicenseButton
